import { CpscPga, CpscValidationArgs } from './types';
import { CompoundPgaValidator } from 'libs/entryValidation/pga/compoundPgaValidator';

/**
 * CPSC compound validator that delegates to sub-validators
 * based on processing type (REF, FULL, DISCLAIM)
 */
export class CpscValidator extends CompoundPgaValidator<CpscPga> {
  isApplicable({ pga }: CpscValidationArgs): boolean {
    return Boolean(pga?.processingType);
  }
}
